import { Flex, Heading, Text, Box } from '@chakra-ui/react'
import { LightColorName } from '../../../Data/Types'
import ResultsVirtualLines from './VirtualLinesResultsImage'
interface VirtualLinesResultsProps {
	projectors: 1 | 2
	lines: 1 | 2
	color: LightColorName
}
const VirtualLinesResults: React.FC<VirtualLinesResultsProps> = ({
	projectors,
	lines,
	color,
}) => {
	return (
		<Flex
			height={'11rem'}
			width={{ base: '45%', md: 'auto' }}
			flexDir={'column'}
			justify={{
				base: 'space-between',
				md: undefined,
			}}
			alignItems="center"
		>
			<Heading
				display={{
					base: 'none',
					md: 'initial',
				}}
				mb={'1.5rem'}
				textAlign={'center'}
				size="lg"
			>
				Projection Dimensions
			</Heading>
			<Box
				width={{
					base: projectors === 1 ? '8rem' : '10rem',
					md: projectors === 1 ? '12rem' : '20rem',
				}}
				position={'relative'}
			>
				<Text
					position="absolute"
					top={[3, null, 6]}
					left={[1, null, projectors === 1 ? 7 : 5]}
					fontWeight={'bold'}
				>
					125'
				</Text>
				<ResultsVirtualLines
					lines={lines}
					projectors={projectors}
					color={color}
				/>
				<Text
					textAlign={projectors === 1 ? 'right' : 'center'}
					fontWeight={'bold'}
				>
					12'14' Ea.
				</Text>
			</Box>
			<Box
				textAlign={'center'}
				justifySelf={'flex-end'} // mt={{ base: 0, md: 3.5 }}
				pt={{
					base: '.875rem',
					md: 3.5,
				}}
				fontSize={{
					base: 'sm',
					md: 'xl',
				}}
			>
				<Text fontWeight={'bold'}>
					{projectors} Set{projectors > 1 && 's'} | {projectors * lines}{' '}
					Projector
					{projectors > 1 && 's'}
				</Text>
				<Text> Line Thickness 3" </Text>
			</Box>
		</Flex>
	)
}

export default VirtualLinesResults
